"use client";

import { ErrorBoundary } from "@/components/error-boundary";
import { logger } from "@/utils/logger";
import { APIProvider } from "@vis.gl/react-google-maps";
import { ReactNode, useEffect } from "react";

export function MapProvider({ children }: { children: ReactNode }) {
	// Preload the Google Maps API with necessary libraries
	useEffect(() => {
		if (typeof window !== "undefined") {
			if (window.google && window.google.maps) {
				// Ensure all required libraries are loaded
				Promise.all([
					window.google.maps.importLibrary("marker"),
					window.google.maps.importLibrary("places"),
					window.google.maps.importLibrary("geometry"),
				]).catch(error => {
					// eslint-disable-next-line no-console
					console.error("Failed to load Google Maps libraries:", error);
				});
			}
		}
	}, []);

	// Check if API key is available
	const apiKey = process.env.NEXT_PUBLIC_GOOGLE_MAP_API_KEY;

	if (!apiKey) {
		logger.error("Google Maps API key is not configured");
		return <div>{children}</div>;
	}

	return (
		<ErrorBoundary>
			<APIProvider apiKey={apiKey} libraries={["marker", "places", "geometry"]}>
				{children}
			</APIProvider>
		</ErrorBoundary>
	);
}
